import styled from 'styled-components';

export const Container = styled.div`
  margin: 0 auto;
  & > div {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    background: ${props => props.theme.containerBackground || 'white'};
    border-radius: 10px;
    padding: 20px;
    cursor: pointer;
  }

  .p {
    font-size: 100px;
    text-align: center; 
  }
`
export const Form = styled.form`
  display: flex;
  flex-direction: column;
  & > * {
    margin-bottom: 10px !important;
 }
`;
